import { ref, readonly } from 'vue';

const _isVisibleModalRefill = ref(false); // 자동충전 모달 노출 여부
const _isRequiredRefill = ref(false); // 필수 입력사항 여부(true: 닫을 수 없음)

export const useModalRefill = () => {
  const isVisibleModalRefill = readonly(_isVisibleModalRefill);
  const isRequiredRefill = readonly(_isRequiredRefill);

  const openModalRefill = ({ isRequired = false } = { isRequired: false }) => {
    _isVisibleModalRefill.value = true;
    _isRequiredRefill.value = isRequired;
  };

  const closeModalRefill = () => {
    _isVisibleModalRefill.value = false;
  };

  return {
    isVisibleModalRefill,
    isRequiredRefill,
    openModalRefill,
    closeModalRefill,
  };
};
